module.exports = __webpack_public_path__ + "static/media/wantaburgerTextImage.bea3cd75.png";